import React, { useState, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./components/Header";
import Main from "./components/Main";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./components/dashboard";

function App() {
  const [darkMode, setDarkMode] = useState(false);

  const theme = useMemo(
    () =>
      createTheme({
        palette: { mode: darkMode ? "dark" : "light" },
      }),
    [darkMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        {/* <Header darkMode={darkMode} setDarkMode={setDarkMode} /> */}
        <Routes>
          {/* Route with clientId param */}
          <Route path="/client/:clientId" element={<Main darkMode={darkMode} setDarkMode={setDarkMode} />} />

          {/* Empty state if no ID */}
          <Route path="/client" element={<Main darkMode={darkMode} setDarkMode={setDarkMode} />} />
          <Route path="/analytics" element={<Dashboard />} />
          {/* Redirect root to /client */}
          <Route path="/" element={<Navigate to="/client" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
